module.exports = __webpack_public_path__ + "png/cards4.png?f3564f96ae95ce79d045469af27aeb9f";